module.exports = __webpack_public_path__ + "static/media/ir.1a62e10d.svg";